import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { MetaInput } from '.';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';

function SingleRepeatInput({
  metaTags,
  isRGroup,
  fileIndex,
  tagIndex,
  handleInputChange,
  isSingleRepeatingField,
  parentUserInput,
  setShowModal,
  id,
  intl,
}) {
  const [repeatingInputs, setRepeatingInputs] = useState(
    Array.isArray(parentUserInput) ? parentUserInput : []
  );
  const [entryToAddInput, setEntryToAddInput] = useState('');
  const [isChangesMade, setIsChangesMade] = useState(false);
  const handleEntryToAdd = (_, __, newValue) => {
    setEntryToAddInput(newValue);
  };

  const handleReatingInputsChange = (_, repeatingInputIndex, newValue) => {
    setIsChangesMade(true);
    setRepeatingInputs((prevRepeatingInputs) => {
      const temp = [...prevRepeatingInputs];
      temp[repeatingInputIndex] = newValue;
      return temp;
    });
  };

  const addRepetingInput = () => {
    setIsChangesMade(true);
    setRepeatingInputs((prevTags) => [...prevTags, entryToAddInput]);
  };

  const removeRepeatingInputAt = (repeatingInputIndex) => {
    setIsChangesMade(true);
    setRepeatingInputs((prevRepeatingInputs) => {
      const temp = [...prevRepeatingInputs]; // Create a copy of the array
      if (repeatingInputIndex < 0 || repeatingInputIndex >= temp.length) {
        return temp;
      }
      temp.splice(repeatingInputIndex, 1);
      return temp;
    });
  };

  const saveChanges = () => {
    handleInputChange(fileIndex, tagIndex, repeatingInputs);
    setShowModal(false);
  };

  const discardChanges = () => {
    setShowModal(false);
  };

  return (
    <div className="photo-uploader__image-list-Modal-container">
      <div className="photo-uploader__image-list-Modal-custom-body">
        <div>
          <h5>{intl.formatMessage({ id: 'metaInput.newEntry' })}</h5>
          <div
            className={classNames(
              'photo-uploader-horizontal-line',
              'photo-uploader-margin-bottom'
            )}
          />
          <h6>{isSingleRepeatingField ? metaTags.meta.name : ''}</h6>
          <MetaInput
            fileIndex={fileIndex}
            tagIndex={tagIndex}
            handleInputChange={handleEntryToAdd}
            userInput={entryToAddInput}
            metaTag={metaTags}
            isRepeatingInputChild={true}
          />
          <Button
            onClick={addRepetingInput}
            className="photo-uploader-margin-top photo-uploader-margin-bottom"
          >
            {intl.formatMessage({ id: 'general.add' })}
          </Button>
        </div>
        {/* Existing Values */}
        {repeatingInputs.length > 0 && (
          <div>
            <h5>{intl.formatMessage({ id: 'metaInput.existingEntries' })}</h5>
            <div
              className={classNames(
                'photo-uploader-horizontal-line',
                'photo-uploader-margin-bottom'
              )}
            />
            {repeatingInputs.map((inputs, repeatingInputIndex) => {
              return (
                <div key={id + '_' + repeatingInputIndex}>
                  <h6 className="photo-uploader__image-list-Modal-entry-number">
                    {intl.formatMessage(
                      { id: 'metaInput.entryNum' },
                      { number: repeatingInputIndex + 1 }
                    )}
                  </h6>
                  <h6>{metaTags.meta.name}</h6>
                  <MetaInput
                    fileIndex={fileIndex}
                    tagIndex={repeatingInputIndex}
                    handleInputChange={handleReatingInputsChange}
                    userInput={inputs}
                    metaTag={metaTags}
                    isRepeatingInputChild={true}
                  />
                  <Button
                    onClick={() => {
                      removeRepeatingInputAt(repeatingInputIndex);
                    }}
                    className="photo-uploader-margin-top photo-uploader-margin-bottom"
                  >
                    {intl.formatMessage({ id: 'general.remove' })}
                  </Button>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="photo-uploader__image-list-Modal-custom-footer">
        <div
          className={classNames(
            'photo-uploader-horizontal-line',
            'photo-uploader-margin-bottom'
          )}
        />
        <div>
          {isChangesMade && (
            <Button onClick={() => discardChanges()} className={'mg-right-5'}>
              {intl.formatMessage({
                id: 'general.cancel',
              })}
            </Button>
          )}
          <Button
            onClick={() => (isChangesMade ? saveChanges() : discardChanges())}
          >
            {intl.formatMessage({
              id: isChangesMade ? 'general.save' : 'general.close',
            })}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(SingleRepeatInput);
